import { EmojiDizzy } from 'react-bootstrap-icons';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';

import { Button, Typography } from 'antd';

import EmptyState from '@/components/shared/EmptyState';
import Wrapper from '@/components/shared/Wrapper';
import { useAppSelector } from '@/hooks/redux';
import { logout } from '@/services/token';
import styled, { StyledProp } from '@/styled';

const Content = ({ className }: StyledProp) => {
  const { courseHash, lessonId } = useParams();
  const [searchParams] = useSearchParams();
  const user = useAppSelector(state => state.auth.user);
  const accessId = Number(searchParams.get('access_id') ?? '0');

  const makeLogout = () => {
    logout();
  };

  if (user?.id === accessId) {
    return <Navigate to={getUrl(courseHash as string, lessonId)} />;
  }

  return (
    <Wrapper className={className}>
      <EmptyState
        icon={<EmojiDizzy />}
        title='Esse conteúdo não pertence ao usuário logado.'
        description={
          <>
            <Typography>Esse conteúdo não pertence ao usuário logado.</Typography>
            <Typography>{user && user?.email}</Typography>
            <Typography>Por favor troque de usuário e tente novamente.</Typography>
            <Button size='large' className='buttonChangeUserContent' type='primary' onClick={makeLogout}>
              Trocar de usuário
            </Button>
          </>
        }
      />
    </Wrapper>
  );
};

function getUrl(courseHash: string, lessonId?: string) {
  const url = `/curso/${courseHash}`;

  if (lessonId) {
    return `${url}/aula/${lessonId}`;
  }

  return url;
}

export default styled(Content)`
  .buttonChangeUserContent {
    margin-top: 10px;
  }
`;
